<template>
  <!-- 底部面板 -->
  <transition name="fade-slide-vertical">
    <div
      v-if="getPannelInfo && getPannelInfo.position === 'bottom' && !isSidePanelVisible"
      class="BottomPannel"
    >
      <div class="bottom-title" @click="showPannelKey = ''">
        <el-icon  style="cursor: pointer" size="21">
          <CircleClose />
        </el-icon>
      </div>

      <component
        ref="comRef"
        :searchValue="searchValue"
        :is="getPannelInfo?.com"
        v-model:bridgeId="bridgeId"
        v-model:markInfoId="markInfoId"
        v-model:resumId="resumId"
      ></component>
    </div>
  </transition>

  <!-- 侧边面板 -->
  <transition name="fade-slide-horizontal">
    <div v-if="getPannelInfo && getPannelInfo.position !== 'bottom'" class="BasePannel">
      <div class="BasePannel-title">
        <div class="BasePannel-title-pre">
          <img
            v-if="getPannelInfo && getPannelInfo.picture !== ''"
            class="BasePannel-title-pre-img"
            :src="getPannelInfo?.picture || ''"
            alt=""
          />
          <span>{{ getPannelInfo ? getPannelInfo.name + '列表' : '' }}</span>
        </div>
        <el-icon @click="showPannelKey = ''" style="cursor: pointer" size="21">
          <CircleClose />
        </el-icon>
      </div>

      <div class="BasePannel-content">
        <component
          style="height: 100%"
          ref="comRef"
          :searchValue="searchValue"
          :is="getPannelInfo?.com"
          v-model:bridgeId="bridgeId"
          v-model:markInfoId="markInfoId"
          v-model:resumId="resumId"
        ></component>
      </div>
    </div>
  </transition>
</template>

<script lang="ts" setup>
import { computed, nextTick, ref } from 'vue'
import { widgetBtnList } from './widgetOptions'
import { CircleClose } from '@element-plus/icons-vue'

const comRef = ref()
const showPannelKey = defineModel<string>('bandKey')
const searchValue = defineModel<string>('searchValue')
const bridgeId = defineModel<number>('bridgeId')
const markInfoId = defineModel<number>('markInfoId')
const resumId = defineModel<number>('resumId')

// 根据当前显示的面板键值获取面板信息
const getPannelInfo = computed(() => {
  return widgetBtnList.find((item) => item.key === showPannelKey.value)
})

// 判断是否显示侧边面板
const isSidePanelVisible = computed(() => {
  return getPannelInfo.value && getPannelInfo.value.position !== 'bottom'
})

// 暴露方法以供父组件调用
defineExpose({
  getList: () => {
    nextTick(() => {
      comRef.value?.getList()
    })
  },
})
</script>

<style lang="scss" scoped>
.BasePannel,
.BottomPannel {
  position: absolute;
  z-index: 10; /* 确保面板在地图上方 */
  background-color: rgba(255, 255, 255, 0.5); /* 半透明背景 */
  backdrop-filter: blur(9px); /* 模糊效果 */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); /* 阴影效果 */
  border-radius: 6px;
  padding: 16px;
}
.bottom-title {
  position:absolute;
  right:20px;
  display:flex;
  justify-content: end;
  padding-right: 10px;
  cursor:pointer;
  z-index:999;
}
.BasePannel {
  width: 360px;
  top: calc(40px + 24px);
  left: 16px;
  height: 80vh;
  display: flex;
  flex-direction: column;

  &-title {
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &-pre {
      font-weight: bold;
      display: flex;
      align-items: center;

      &-img {
        width: 20px;
        height: 20px;
      }

      > span {
        padding-left: 10px;
      }
    }
  }

  &-content {
    flex: 1;
    height: 100%;
  }
}

.BottomPannel {
  bottom: 0;
  left: 0;
  right: 0;
  height: 300px;
}

/* 添加上下平移动画样式 */
.fade-slide-vertical-enter-active,
.fade-slide-vertical-leave-active {
  transition: all 0.3s ease;
}
.fade-slide-vertical-enter-from,
.fade-slide-vertical-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

.fade-slide-horizontal-enter-active,
.fade-slide-horizontal-leave-active {
  transition: all 0.3s ease;
}
.fade-slide-horizontal-enter-from {
  opacity: 0;
  transform: translateX(-20px); /* 从左到右弹出 */
}
.fade-slide-horizontal-leave-to {
  opacity: 0;
  transform: translateX(-20px); /* 从右往左收起 */
}
</style>
